// plugins/screenAdapt.js
export default {
  install(Vue, options = {}) {
    const config = {
      baseWidth: options.baseWidth || 1920,
      minZoom: options.minZoom || 0.5,
      maxZoom: options.maxZoom || 1.2,
      debounceTime: options.debounceTime || 100
    };

    // 防抖函数
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // 计算zoom的方法
    function calculateZoom() {
      const currentWidth = window.innerWidth;
      let zoom = currentWidth / config.baseWidth;
      
      zoom = Math.max(zoom, config.minZoom);
      zoom = Math.min(zoom, config.maxZoom);
      
      // document.body.style.zoom = zoom;
      return zoom;
    }

    const debouncedCalculateZoom = debounce(calculateZoom, config.debounceTime);

    // 添加到Vue原型
    Vue.prototype.$calculateZoom = calculateZoom;
    Vue.prototype.$getZoomConfig = () => ({ ...config });

    // 初始计算
    calculateZoom();

    // 监听窗口调整
    window.addEventListener('resize', debouncedCalculateZoom);

    // 保存引用以便后续清理
    Vue._screenAdaptHandler = debouncedCalculateZoom;
  }
};